import { ref } from 'vue'
import { useRuntimeConfig, useI18n } from '#imports'
import { createSharedComposable } from '@vueuse/core'

function _useStripe() {
    const { shopwareAppShopId } = useRuntimeConfig().public
    const i18n = useI18n()
    const localeProperties = (i18n as unknown as { localeProperties?: { value?: { language?: string } } }).localeProperties
    const locale = localeProperties?.value?.language ?? 'en-GB'

    const stripe = ref()
    const elements = ref()
    const configs = ref()
    const isElementReady = ref(false)
    const options = ref({
        appShopId: shopwareAppShopId,
        locale,
        appUrl: 'https://production.shopware.stripeconnectors.com',
        appVersion: '1.4.0'
    })

    return {
        stripe,
        elements,
        configs,
        options,
        isElementReady
    }
}

export const useStripe = createSharedComposable(_useStripe)
